import Vue from 'vue'

import {
  Upload,
  Button,
  Select,
  Form,
  FormItem,
  Table,
  TableColumn,
  Footer,
  Loading,
  Main,
  Header,
  Dialog,
  Option,
  OptionGroup,
  DatePicker,
  TimeSelect,
  TimePicker,
  MessageBox,
  Message,
  Input,
  Menu,
  Submenu,
  MenuItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Steps,
  Step,
  Pagination,
  Tag,
  Divider,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Switch,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  Tree,
  Container,
  Aside,
  Row,
  Col,
  Radio,
  Tabs,
  TabPane,
  Descriptions,
  DescriptionsItem,
  RadioGroup,
  RadioButton,
  Tooltip,
  Card,
  Slider,
  Progress,
  Image,
  Autocomplete
} from 'element-ui'

import TableHide from './TableHide/index.js'

Vue.prototype.$ELEMENT = { size: 'mini' };
Vue.use(Button)
Vue.use(Autocomplete)
Vue.use(Upload)
Vue.use(Tooltip)
Vue.use(Slider)
Vue.use(Select)
Vue.use(Form)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
Vue.use(Main)
Vue.use(Header)
Vue.use(Dialog)
Vue.use(Footer)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
// Vue.use(Message)
Vue.use(Input)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Pagination)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Switch)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tree)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(TableHide)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Card)
Vue.use(Progress)

Vue.use(Image)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message


// WEBPACK FOOTER //
// ./src/components/index.js